import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/travel/accommodations`;

export const getAccommodations = () => axios.get(BASE_URL);
export const createAccommodation = (data: any) => axios.post(BASE_URL, data);
export const updateAccommodation = (id: string, data: any) =>
  axios.put(`${BASE_URL}/${id}`, data);
export const deleteAccommodation = (id: string) =>
  axios.delete(`${BASE_URL}/${id}`);
